// extracted by mini-css-extract-plugin
export default {"appBody":"App_appBody__dQCZD","appBody-Dark":"App_appBody-Dark__Ufczy","blur":"App_blur__jXasR"};